import { render } from "./LearningGoalsView.vue?vue&type=template&id=09d60f82"
import script from "./LearningGoalsView.vue?vue&type=script&lang=js"
export * from "./LearningGoalsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__